/**
 * Based on the code for when to mark LCP in the web-vitals package
 * https://github.com/GoogleChrome/web-vitals/blob/main/src/onLCP.ts
 */
export function listenForInteractionOrHide(cb) {
    var callbackCalled = false;
    var cbWrapped = function () {
        if (!callbackCalled) {
            callbackCalled = true;
            cb();
        }
    };
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' ||
            document.visibilityState === 'hidden') {
            cbWrapped();
            window.removeEventListener(event.type, onHiddenOrPageHide);
        }
    };
    window.addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    window.addEventListener('pagehide', onHiddenOrPageHide, true);
    var interactionEvents = ['keydown', 'click'];
    var interactionListener = function () {
        cbWrapped();
        interactionEvents.forEach(function (type) {
            window.removeEventListener(type, interactionListener);
        });
    };
    interactionEvents.forEach(function (type) {
        window.addEventListener(type, interactionListener, true);
    });
}
//# sourceMappingURL=utils.js.map